module.exports = __webpack_public_path__ + "img/image_2-e777907c.png";